import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'

import admin from './admin/reducers'
import alerts from './alerts/reducers'
import artists from './artists/reducers'
import auth from './auth/reducers'
import contentModules from './contentModules/reducers'
import contentOps from './contentOps/reducers'
import dashboard from './dashboard/reducers'
import dataFields from './datafields/reducers'
import events from './events/reducers'
import eventsUpdate from './eventsUpdate/reducers'
import flags from './flags/reducers'
import heroContents from './heroContents/reducers'
import marquee from './marquee/reducers'
import navigations from './navigations/reducers'
import optInModal from './optInModal/reducers'
import organizations from './organizations/reducers'
import pages from './pages/reducers'
import priceTemplates from './priceTemplates/reducers'
import promoCodes from './promocodes/reducers'
import publishingPreferences from './publishingPreferences/reducers'
import series from './series/reducers'
import sphereFlags from './sphereFlags/reducers'
import sponsors from './sponsors/reducers'
import suiteCards from './suiteCards/reducers'
import tmImportLogs from './tmImportLogs/reducers'
import venues from './venues/reducers'
import vlpCards from './vlpCards/reducers'

export default (history) => combineReducers({
  admin,
  alerts,
  artists,
  auth,
  contentModules,
  contentOps,
  dataFields,
  dashboard,
  events,
  eventsUpdate,
  flags,
  heroContents,
  marquee,
  navigations,
  optInModal,
  organizations,
  pages,
  priceTemplates,
  promoCodes,
  publishingPreferences,
  router: connectRouter(history),
  series,
  sphereFlags,
  sponsors,
  suiteCards,
  tmImportLogs,
  venues,
  vlpCards
})
